import { Route, Switch } from 'react-router-dom';

import { ROUTES } from '../../constants/routes';
import { UserPermissions } from './pages/UserPermissions';

export const UserPermissionsRoutes = () => (
  <Switch>
    <Route path={ROUTES.USER_PERMISSIONS} exact={true} component={UserPermissions} />
  </Switch>
);
